/**
 * @generated SignedSource<<4d92e9a65b17a33d1d9ca24d5e20a63c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type designTemplatesQueriesSetTemplateAsDefaultMutation$variables = {
  colorIDs?: ReadonlyArray<number> | null;
  modelId: number;
  templateId: string;
};
export type designTemplatesQueriesSetTemplateAsDefaultMutation$data = {
  readonly setTemplateAsDefault: {
    readonly colors: ReadonlyArray<{
      readonly colorID: number;
      readonly isDefault: boolean;
      readonly name: string | null;
    } | null>;
    readonly designTemplateId: number;
    readonly id: string;
    readonly name: string;
    readonly previewUrl: string;
  };
};
export type designTemplatesQueriesSetTemplateAsDefaultMutation = {
  response: designTemplatesQueriesSetTemplateAsDefaultMutation$data;
  variables: designTemplatesQueriesSetTemplateAsDefaultMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "colorIDs"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "modelId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "templateId"
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "colorIDs",
        "variableName": "colorIDs"
      },
      {
        "kind": "Variable",
        "name": "modelId",
        "variableName": "modelId"
      },
      {
        "kind": "Variable",
        "name": "templateId",
        "variableName": "templateId"
      }
    ],
    "concreteType": "DesignTemplate",
    "kind": "LinkedField",
    "name": "setTemplateAsDefault",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "designTemplateId",
        "storageKey": null
      },
      (v3/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "previewUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DesignTemplateColor",
        "kind": "LinkedField",
        "name": "colors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "colorID",
            "storageKey": null
          },
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isDefault",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "designTemplatesQueriesSetTemplateAsDefaultMutation",
    "selections": (v4/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "designTemplatesQueriesSetTemplateAsDefaultMutation",
    "selections": (v4/*:: as any*/)
  },
  "params": {
    "cacheID": "1a431004357e74ee4faabc8f85ae2916",
    "id": null,
    "metadata": {},
    "name": "designTemplatesQueriesSetTemplateAsDefaultMutation",
    "operationKind": "mutation",
    "text": "mutation designTemplatesQueriesSetTemplateAsDefaultMutation(\n  $modelId: Long!\n  $templateId: ID!\n  $colorIDs: [Long!]\n) {\n  setTemplateAsDefault(modelId: $modelId, templateId: $templateId, colorIDs: $colorIDs) {\n    id\n    designTemplateId\n    name\n    previewUrl\n    colors {\n      colorID\n      name\n      isDefault\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "0f679618c74999737ed4a170e5ea4f5e";

export default node;
